export const initialize = (applicationInstance) => {
  const moment = applicationInstance.lookup('service:moment');

  // add an override to handle case where we have a few second drift b/t browser and server time.  Basically,
  // never show the 'in a few seconds' case and just always say 'a moment ago'
  moment.updateLocale('en', {
    relativeTime: {
      future(input) {
        return input === 'a few seconds' ? 'a moment ago' : input;
      },
    },
  });
};

export default {
  initialize,
};
